import React, { useState } from "react";
import { useAdminAuth } from "@/contexts/AdminAuthContext";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login } = useAdminAuth();
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!password) return;
        setSubmitting(true); setError("");
        try {
            await login(password);
            toast.success("Welcome back");
        } catch (err) {
            const msg = err?.response?.data?.detail || err?.message || "Login failed";
            setError(typeof msg === "string" ? msg : JSON.stringify(msg));
        } finally { setSubmitting(false); }
    };

    return (
        <div className="bg-paper min-h-screen flex items-center justify-center px-6">
            <form onSubmit={onSubmit} className="w-full max-w-md bg-ivory p-10" data-testid="admin-login-form">
                <div className="flex flex-col items-center text-center">
                    <div className="w-12 h-12 rounded-full bg-ink text-paper flex items-center justify-center">
                        <Lock size={18} />
                    </div>
                    <p className="overline mt-6">Admin Console</p>
                    <h1 className="font-serif text-4xl text-ink mt-3">Locked.</h1>
                    <p className="mt-3 text-sm text-charcoal max-w-xs">Enter the admin password to view enquiries, edit settings, and trigger Shopify syncs.</p>
                </div>

                <div className="mt-8 space-y-4">
                    <Input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Admin password"
                        autoFocus
                        data-testid="admin-login-password"
                        className="bg-white border-soft h-12 text-base"
                    />
                    {error && <p className="text-xs text-red-700" data-testid="admin-login-error">{error}</p>}
                    <button
                        type="submit"
                        disabled={submitting || !password}
                        data-testid="admin-login-submit"
                        className="w-full h-12 bg-ink text-paper uppercase text-[11px] tracking-[0.26em] hover:bg-bronze-deep disabled:opacity-60"
                    >
                        {submitting ? "Verifying…" : "Unlock"}
                    </button>
                </div>

                <p className="mt-8 text-[10px] text-muted-ink uppercase tracking-[0.22em] text-center">
                    Session lasts 30 days on this browser
                </p>
            </form>
        </div>
    );
}
